import type { Question, QuestionStimulus, QuestionType } from '@examflow/core';

/**
 * TOPIK 考试等级 (1级初级 -> 6级高级)
 */
export enum TOPIKLevel {
  Level1 = '1',
  Level2 = '2',
  Level3 = '3',
  Level4 = '4',
  Level5 = '5',
  Level6 = '6',
}

/**
 * TOPIK 考试部分
 */
export enum TOPIKSection {
  /** 听力 */
  LISTENING = 'listening',
  /** 阅读 */
  READING = 'reading',
  /** 写作 (仅 TOPIK II) */
  WRITING = 'writing',
}

/**
 * TOPIK 题目扩展接口
 */
export interface TOPIKQuestion extends Question {
  /** 对应的 TOPIK 等级 */
  topikLevel?: TOPIKLevel;
  /** 所属考试部分 */
  section?: TOPIKSection;
  /** 题目序号（在该部分中） */
  orderInSection?: number;
}

/**
 * TOPIK 听力题目（single_choice + audio stimulus）
 */
export interface TOPIKListeningQuestion extends TOPIKQuestion {
  type: QuestionType.SINGLE_CHOICE;
  stimulus: Extract<QuestionStimulus, 'audio'>[];
  /** 音频URL */
  audioUrl: string;
  /** 音频播放次数限制 */
  maxPlayCount?: number;
  /** 音频时长（秒） */
  audioDuration?: number;
}

/**
 * TOPIK 阅读题目（single_choice + passage stimulus）
 */
export interface TOPIKReadingQuestion extends TOPIKQuestion {
  type: QuestionType.SINGLE_CHOICE;
  stimulus: Extract<QuestionStimulus, 'passage'>[];
  /** 阅读材料 */
  passage: string;
  /** 材料来源 */
  source?: string;
}

/**
 * TOPIK 分数与等级对照表
 */
export interface TOPIKScoreMapping {
  level: TOPIKLevel;
  minScore: number;
  maxScore: number;
  description: string;
}

/**
 * TOPIK 考试结果
 */
export interface TOPIKResult {
  /** 总分 */
  totalScore: number;
  /** 等级 */
  level: TOPIKLevel;
  /** 各部分得分 */
  sectionScores: Record<TOPIKSection, number>;
  /** 及格 */
  passed: boolean;
  /** 详细评价 */
  evaluation: string;
}
